import type { SxProps, Theme } from '@mui/material';

const dialogPaper = (isMobile: boolean): SxProps<Theme> => (isMobile ? { borderRadius: 0 } : { borderRadius: '8px' });

const dialogTitle: SxProps<Theme> = {
  fontWeight: 700,
  fontSize: 16,
  py: 1.5,
};

const dialogContent: SxProps<Theme> = { py: 2 };

const form = (isMobile: boolean): SxProps<Theme> => ({
  display: 'flex',
  gap: 1.5,
  alignItems: isMobile ? 'stretch' : 'flex-end',
  flexDirection: isMobile ? 'column' : 'row',
});

const formFields: SxProps<Theme> = { display: 'flex', gap: 1.5, flex: 1 };

const formField: SxProps<Theme> = { flex: 1 };

const searchButton = (isMobile: boolean): SxProps<Theme> => ({
  fontWeight: 600,
  whiteSpace: 'nowrap',
  ...(isMobile && { py: 1.25 }),
});

const alert: SxProps<Theme> = { mt: 2 };

const resultSection: SxProps<Theme> = { mt: 2 };

const resultLabel: SxProps<Theme> = { mb: 1 };

const resultList: SxProps<Theme> = {
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: 1,
  maxHeight: 280,
  overflow: 'auto',
};

const dialogActions: SxProps<Theme> = { px: 2, py: 1.5 };

const textButton: SxProps<Theme> = { textTransform: 'none' };

const confirmButton: SxProps<Theme> = { textTransform: 'none', fontWeight: 600 };

export const styles = {
  dialogPaper,
  dialogTitle,
  dialogContent,
  form,
  formFields,
  formField,
  searchButton,
  alert,
  resultSection,
  resultLabel,
  resultList,
  dialogActions,
  textButton,
  confirmButton,
} as const;
